// src/components/LoginForm.jsx
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { login } from "../services/authService";
import "../styles/auth.css";
import { useI18n } from "../providers/I18nProvider";
import { useAuth } from "../contexts/AuthContext";

// Güvenlik: return_url sadece izin verilen host'lara yönlendirme yapabilsin.
// Aynı origin, bozankayateknoloji.com alt domain'leri ve LAN'daki panel host'u (192.168.10.4) kabul.
const ALLOWED_LAN_HOSTS = ["192.168.10.4"];
const isSafeReturnUrl = (raw) => {
  if (!raw) return false;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin === window.location.origin) return true;
    const host = url.hostname.toLowerCase();
    if (host === "bozankayateknoloji.com" || host.endsWith(".bozankayateknoloji.com")) return true;
    if (ALLOWED_LAN_HOSTS.includes(host)) return true;
    return false;
  } catch {
    return false;
  }
};

const LoginForm = () => {
  const { t } = useI18n();
  const { refresh: refreshAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get("return_url");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { token } = await login(email, password);

      // Kimlik dogrulama HttpOnly cookie ile yapiliyor; eski surumlerden
      // kalan localStorage kayitlari AuthContext init'te zaten temizleniyor.

      // SSO redirect: başka bir panelden gelindiyse token'ı URL hash ile geri gönder.
      // httpOnly cookie harici panel JS'den okunamadığı için hash şart.
      if (returnUrl && isSafeReturnUrl(returnUrl) && token) {
        const sep = returnUrl.includes("#") ? "&" : "#";
        window.location.href = `${returnUrl}${sep}token=${encodeURIComponent(token)}`;
        return;
      }

      // AuthContext uygulama aciilirken bir kez /users/me cagirdi ve 401
      // aldi; login olduktan sonra taze user'i yuklemesi icin refresh
      // tetikleniyor. Yoksa PrivateRoute kullaniciyi login'e geri atar.
      await refreshAuth();

      // Tek anasayfa: tüm roller /dashboard'a gider
      navigate("/dashboard");
    } catch (err) {
      console.error("Giriş hatası:", err.message);
      setError(err.message);
      setTimeout(() => {
        setError(null);
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <div className="auth-field">
        <label className="auth-label" htmlFor="login-email">
          {t("auth.email")}
        </label>
        <input
          id="login-email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder={t("auth.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="auth-field">
        <label className="auth-label" htmlFor="login-password">
          {t("auth.password")}
        </label>
        <input
          id="login-password"
          type="password"
          autoComplete="current-password"
          placeholder={t("auth.password")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit" disabled={loading}>
        {loading ? t("auth.loggingIn") : t("auth.login")}
      </button>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Link to="/forgot-password">{t("auth.forgotPassword.link")}</Link>
      </div>
      {error && <div className="error-box">{error}</div>}
    </form>
  );
};

export default LoginForm;
